import "../styles/OurPartner.css";

const partners = [
  { name: "SATTVICHR ", link: "https://sattvichr.com" },
  
];

const staticLines = ["OUR HR TEAM"];

const OurPartner = () => {
  const combinedItems = [...partners.map(p => ({ ...p, isLink: true })), ...staticLines.map(text => ({ name: text, isLink: false }))];

  return (
    <div className="partner-banner">
      <div className="scrolling-track">
        {[...Array(5)].map((_, i) => (
          combinedItems.map((item, index) =>
            item.isLink ? (
              <a
                key={`${i}-${index}`}
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                className="partner-item"
              >
                OUR PARTNER - {item.name}
              </a>
            ) : (
              <span key={`${i}-${index}`} className="partner-item">
                {item.name}
              </span>
            )
          )
        ))}
      </div>
    </div>
  );
};

export default OurPartner;
